import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { render } from "preact";
import App from "./App";
import "./global.css";
/* After Tailwind preflight so Playfair heading sizes are not overridden (h1/h2 use same specificity). */
import "@/pages/HomePage.css";

const queryClient = new QueryClient();

render(
	<QueryClientProvider client={queryClient}>
		<App />
	</QueryClientProvider>,
	document.getElementById("app")!,
);
